import React from 'react';
import { motion } from 'framer-motion';
import { InboxIcon, PhoneCallIcon, MegaphoneIcon, RefreshCwIcon, type LucideIcon } from 'lucide-react';
import { usePrefersReducedMotion } from './motion';
const stages: {
  icon: LucideIcon;
  label: string;
}[] = [{
  icon: InboxIcon,
  label: 'Lead comes in'
}, {
  icon: PhoneCallIcon,
  label: 'Something answers'
}, {
  icon: MegaphoneIcon,
  label: 'Ads stay full'
}, {
  icon: RefreshCwIcon,
  label: 'CRM keeps chasing'
}];

/* An "at a glance" summary that sits above the System section's existing
   numbered list -- the list still carries the detail, this carries the
   shape of it in one look. Four nodes matching the four systemSteps,
   connected by the same animated-dashed-path technique LeadFlowVisual
   already established elsewhere on the site, so a new visual doesn't
   introduce a competing style. */
export function ProcessFlowVisual() {
  const reducedMotion = usePrefersReducedMotion();
  return <div className="w-full overflow-x-auto" data-id="element-805" data-mp="3410mkhcg8m50">
      <div className="flex min-w-[560px] items-center justify-between gap-2 rounded-2xl border border-[#1c1c1c] bg-[#0a0a0a] px-6 py-8 sm:px-10" data-id="element-806" data-mp="2ihz3vimre21o">
        {stages.map((stage, i) => {
        const Icon = stage.icon;
        return <React.Fragment key={stage.label} data-id="element-807" data-mp="2s7r1klq5nbad" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex flex-col items-center text-center" data-id="element-808" data-mp="2n8xm4nrb5a7k">
                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10" data-id="element-809" data-mp="28lckkya2zj1r">
                  <Icon className="h-5 w-5 text-emerald-500" aria-hidden="true" data-id="element-810" data-mp="24lc6jeqw99v8" />
                </span>
                <span className="mt-3 w-20 font-mono text-[10px] uppercase leading-tight tracking-[0.1em] text-neutral-500" data-id="element-811" data-mp="3k1krfbwjpgj8">
                  {stage.label}
                </span>
              </motion.div>
              {i < stages.length - 1 && <svg className="h-3 w-full max-w-[64px] shrink-0 sm:max-w-[96px]" viewBox="0 0 100 12" preserveAspectRatio="none" aria-hidden="true" data-id="element-812" data-mp="2hl93r4ntrjnu">
                  <line x1="0" y1="6" x2="100" y2="6" stroke="#232323" strokeWidth="1.5" data-id="element-813" data-mp="2mjk84zvcp1yo" />
                  {!reducedMotion && <motion.line x1="0" y1="6" x2="100" y2="6" stroke="#10b981" strokeWidth="1.5" strokeDasharray="14 90" initial={{
              strokeDashoffset: 104
            }} animate={{
              strokeDashoffset: 0
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'linear',
              delay: i * 0.35
            }} data-id="element-814" data-mp="1txisgydxmi0p" />}
                </svg>}
            </React.Fragment>;
      })}
      </div>
    </div>;
}